import PageLayout from './PageLayout';

export default function ContactPage() {
  return (
    <PageLayout>
      <section style={{ maxWidth: '500px', margin: '0 auto', padding: '4rem 2rem', textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '1rem' }}>Contact</h1>

        <p style={{ color: '#94a3b8', fontSize: '0.95rem', lineHeight: 1.7 }}>
          For questions, feedback, or support inquiries:
        </p>

        <a
          href="mailto:contact@xposureflow.io"
          style={{
            display: 'inline-block', marginTop: '1.5rem',
            color: '#3b82f6', fontSize: '1.125rem', fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          contact@xposureflow.io
        </a>

        <p style={{ color: '#64748b', fontSize: '0.8rem', marginTop: '2rem', lineHeight: 1.6 }}>
          We aim to respond within 1&ndash;2 business days.
        </p>
      </section>
    </PageLayout>
  );
}
